import { connect } from 'react-redux'
import List from '../_List'
import { selectMedal } from '../../../../actions'

const toggleDialog = (id,toggleOpen,dispatch) =>{
  console.log(`CLICK ${id}`)
  // DISPATCH
  dispatch(selectMedal({id: id}))
  toggleOpen()
}


const mapStateToProps = state => ({
  list_name: 'Medallas',
  empty_message: '¡No has ganado ninguna medalla!',
  items: state.user.medals.map(x =>
    ({ ...x, text: x.description }),
  ),
})

const mapDispatchToProps = dispatch => ({
  toggleDialog: (id,toggleOpen) => toggleDialog(id,toggleOpen,dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(List)



// WEBPACK FOOTER //
// ./src/components/Main/Profile/Medals/index.jsx